"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_dom_1 = require("react-dom");
const GlobalContext_1 = require("../../context/GlobalContext");
const styles = {
    popup: {
        position: 'fixed',
        top: 0,
        left: 0,
        pointerEvents: 'none',
        backgroundColor: 'gray',
        padding: '3px',
        borderRadius: '2px',
        color: 'white',
        whiteSpace: 'nowrap',
        fontSize: '10px',
        fontFamily: 'tahoma',
        textShadow: 'none',
    },
};
function ToolTip({ style = { popup: {}, mainContainer: {} }, className = '', popupPlacement = 'right', children, title, offset = { x: 0, y: 0 }, }) {
    const refChild = (0, react_1.useRef)(null);
    const refContent = (0, react_1.useRef)(null);
    const [placement, setPlacement] = (0, react_1.useState)({ x: 0, y: 0 });
    const [show, showToolTip] = (0, react_1.useState)(false);
    const { elementsWrapperRef } = (0, GlobalContext_1.useGlobal)();
    (0, react_1.useLayoutEffect)(() => {
        const getPopupPlacement = () => {
            let x;
            let y;
            if (refChild.current === null || refContent.current === null) {
                return null;
            }
            const childBounding = refChild.current.getBoundingClientRect();
            const contentBounding = refContent.current.getBoundingClientRect();
            switch (popupPlacement) {
                case 'left':
                    x = -contentBounding.width;
                    y =
                        childBounding.height / 2 -
                            ((childBounding.height / 2) * contentBounding.height) /
                                childBounding.height;
                    break;
                case 'right':
                    x = childBounding.width;
                    y =
                        childBounding.height / 2 -
                            ((childBounding.height / 2) * contentBounding.height) /
                                childBounding.height;
                    break;
                case 'top':
                    x =
                        childBounding.width / 2 -
                            ((childBounding.width / 2) * contentBounding.width) /
                                childBounding.width;
                    y = -childBounding.height;
                    break;
                case 'bottom':
                    x =
                        childBounding.width / 2 -
                            ((childBounding.width / 2) * contentBounding.width) /
                                childBounding.width;
                    y = childBounding.height;
                    break;
                default:
                    x = 0;
                    y = 0;
                    break;
            }
            return { x: x + childBounding.x, y: y + childBounding.y };
        };
        if (show) {
            const pl = getPopupPlacement();
            if (pl) {
                setPlacement(pl);
            }
        }
    }, [popupPlacement, show]);
    const mouseOverHandler = (0, react_1.useCallback)(() => {
        showToolTip(true);
    }, []);
    const mouseLeaveHandler = (0, react_1.useCallback)(() => {
        showToolTip(false);
    }, []);
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { style: {
                    position: 'relative',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    ...style.mainContainer,
                }, ref: refChild, onMouseOver: mouseOverHandler, onMouseOut: mouseLeaveHandler, children: children }), show &&
                elementsWrapperRef &&
                (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsx)("div", { ref: refContent, style: {
                        ...styles.popup,
                        transform: `translate(${placement.x + offset.x}px,${placement.y + offset.y}px)`,
                        zIndex: 999999999,
                        ...style.popup,
                    }, className: className, children: (0, jsx_runtime_1.jsx)("span", { style: { pointerEvents: 'none' }, children: title }) }), elementsWrapperRef)] }));
}
exports.default = (0, react_1.memo)(ToolTip);
